var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ arrow: true, theme: 'green' }),expression:"{ arrow: true, theme: 'green' }"}],staticClass:"h-5 w-5 flex items-center justify-center",attrs:{"content":_vm.broker}},[_c('i',{staticClass:"h-5 w-5 flex",domProps:{"innerHTML":_vm._s(_vm.styles)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }